;(function () {
  if (window.__RR_APP_PAGES_STATIC__) return;

  /** 与 SKILL / layout 约定一致：商城当前域 + 官网/账号域放行 */
  var EXTERNAL_LINK_WHITELIST_HOSTS = [
    'account.roborock.com',
    'usaccount.roborock.com',
    'account-us.roborock.com',
    'account-eu.roborock.com',
    'test-tempaccount.roborock.com',
  ]

  function getWhitelistHosts() {
    var hosts = EXTERNAL_LINK_WHITELIST_HOSTS.slice()
    var current = window.location && window.location.host
    if (current && hosts.indexOf(current) === -1) {
      hosts.push(current)
    }
    return hosts
  }

  function isWhitelistedHost(host, whitelist) {
    if (!host) return true
    return whitelist.indexOf(host) !== -1
  }

  function shouldBlockExternalUrl(url, whitelist) {
    if (!url || !url.host) return false
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    if (url.host === window.location.host) return false
    return !isWhitelistedHost(url.host, whitelist)
  }

  function showAppExternalLinkBlockedMsg() {
    var msg = window.__APP_EXTERNAL_LINK_BLOCKED_MSG__
    if (!msg) return

    if (window.layer && typeof window.layer.msg === 'function') {
      window.layer.msg(msg, { icon: 0 })
      return
    }

    var id = 'rr-app-external-link-toast'
    var existing = document.getElementById(id)
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing)
    }

    var el = document.createElement('div')
    el.id = id
    el.setAttribute('role', 'status')
    el.textContent = msg
    el.style.cssText =
      'position:fixed;left:50%;bottom:24%;transform:translateX(-50%);max-width:min(320px,80vw);padding:12px 16px;background:rgba(22,22,22,.88);color:#fff;font-size:14px;line-height:1.4;text-align:center;border-radius:8px;z-index:2147483647;pointer-events:none;box-sizing:border-box;'
    ;(document.body || document.documentElement).appendChild(el)
    window.setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el)
    }, 2500)
  }

  function handleDocumentClick(event) {
    var ua = navigator.userAgent || ''
    if (typeof window.__rrMallIsAppWebView__ !== 'function' || !window.__rrMallIsAppWebView__(ua)) {
      return
    }

    var target = event.target
    if (!target || typeof target.closest !== 'function') return

    var link = target.closest('a[href]')
    if (!link) return
    if (link.dataset && link.dataset.allowExternal === 'true') return

    var href = link.getAttribute('href')
    if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) return

    var url
    try {
      url = new URL(href, window.location.href)
    } catch (e) {
      return
    }

    var whitelist = getWhitelistHosts()
    if (!shouldBlockExternalUrl(url, whitelist)) return

    event.preventDefault()
    if (event.stopImmediatePropagation) event.stopImmediatePropagation()
    event.stopPropagation()

    showAppExternalLinkBlockedMsg()

    if (window.nativeBridge && typeof window.nativeBridge.openExternalLink === 'function') {
      window.nativeBridge.openExternalLink(url.href)
    }
  }

  try {
    document.addEventListener('click', handleDocumentClick, true)
  } catch (e) {}
})()
